module.exports = __webpack_public_path__ + "static/media/atif.07c76b18.jpeg";